
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

interface SubscriptionEmptyStateProps {
  hasAvailableTypes: boolean;
}

const SubscriptionEmptyState: React.FC<SubscriptionEmptyStateProps> = ({ hasAvailableTypes }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent className="text-center py-8">
        <p className="text-muted-foreground">
          {t('clients.noSubscriptions')}
        </p>
        <p className="text-sm text-muted-foreground mt-1">
          {hasAvailableTypes 
            ? t('clients.addSubscriptionStart')
            : t('clients.allSubscriptionsAdded')
          }
        </p>
      </CardContent>
    </Card>
  );
};

export default SubscriptionEmptyState;
